// Lib
import React from 'react';
import { TextareaAutosize, Typography } from '@mui/material';

// Hooks
import useUI from '../../../../hooks/useUI';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { Controller, useForm } from 'react-hook-form';

// Validation Schema
import { approveResponseSchema } from '../../../../validationSchema';

import { useStyles } from './ApproveResponseStyles';
import { pickIf } from '../../../../utils/pickIf';

const TITLE_MARGIN_TOP_MD_NOT_APPROVED = 2;
const TITLE_MARGIN_TOP_XS_APPROVED = 2.5;
const TITLE_MARGIN_TOP_XS_NOT_APPROVED = 3.5;
const TEXTAREA_MIN_ROWS_MOBILE = 7;
const TEXTAREA_MIN_ROWS_DESKTOP = 3.5;

const ApproveResponse = ({
  isRequired = false,
  onChangeResponse = () => {},
  isApproved,
  response,
}) => {
  const { classes } = useStyles();
  const { isMobileMode } = useUI();

  const {
    control,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(approveResponseSchema(isRequired)),
    defaultValues: {
      approveResponse: '',
    },
  });

  if (isApproved && !response) {
    return;
  }

  return (
    <>
      <Typography
        component="div"
        mt={{
          md: pickIf(isApproved, 1, TITLE_MARGIN_TOP_MD_NOT_APPROVED),
          xs: pickIf(
            isApproved,
            TITLE_MARGIN_TOP_XS_APPROVED,
            TITLE_MARGIN_TOP_XS_NOT_APPROVED,
          ),
        }}
        variant="textMdBold">
        Your response to the requester{' '}
        {isRequired && !isApproved ? (
          <span className={classes.accent}>*</span>
        ) : (
          ''
        )}
      </Typography>
      <p className={classes.responseInfo}>
        {pickIf(
          response && isApproved,
          response,
          'This message will be sent to the order originator.',
        )}
      </p>
      {!isApproved && (
        <>
          <Controller
            name="approveResponse"
            control={control}
            render={({ field }) => (
              <TextareaAutosize
                {...field}
                placeholder="Type a message"
                className={classes.textArea}
                minRows={
                  isMobileMode
                    ? TEXTAREA_MIN_ROWS_MOBILE
                    : TEXTAREA_MIN_ROWS_DESKTOP
                }
                aria-label="empty textarea"
                onChange={onChangeResponse(field.onChange)}
              />
            )}
          />
          {isRequired && errors?.approveResponse?.message && !isApproved && (
            <span className={classes.error}>
              {errors?.approveResponse?.message}
            </span>
          )}
        </>
      )}
    </>
  );
};

export default ApproveResponse;
